import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceResource } from '../model/serviceResource';
import { CreateCalculationRequest } from '../model/createCalculationRequest';
import { CalculationResource } from '../model/calculationResource';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirstStepService {

  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  fetchServices(): Observable<ServiceResource[]> {
    const apiUrl = this.apiUrl+'/api/service';
    return this.http.get<ServiceResource[]>(apiUrl);
  }

  createCalculation(params: CreateCalculationRequest): Observable<CalculationResource> {
    const apiUrl = this.apiUrl+'/api/calculation';
    return this.http.post<CalculationResource>(apiUrl, params); // Specify the return type
  }

}
